import * as React from 'react';
import ErrorText from "../../atom/text/error_text";
import Label from "../../atom/label/label";
import FormMultiSelect from "../../atom/form/form_multi_select";

interface IProps {
    type: string;
    isMulti?: boolean;
    required?: boolean;
    options: any;
    name: string;
    label: string;
    placeholder: string;
    hasError: boolean;
    errorText: string;
    input?: any;
    require?: boolean;
}

const FormGroupMultiSelect: React.FC<IProps> = (props) => {

    const {type, isMulti, options, name, label, placeholder, hasError, errorText, children,
        input, require
    } = props;

    // options: {value: number, label: string}[] からvalue指定で単体オブジェクトを所得したいための連想配列
    const hashOptions: { [value: number]: {}} = {};

    for (const option of options) {
        hashOptions[option.value] = option;
    }

    // redux-formへ返す値の処理 ライブラリの中では{value: string}[] で処理されるが、 string[] にしたいため
    const onChange = (value: any) => {
        const returnValue = value ?
            value.map((item: any) => item.value)
            : [];
        return input.onChange(returnValue);
    };
    // redux-form + react-select + mobile 対応？ 下記参考
    // https://github.com/JedWatson/react-select/issues/2692
    const onBlur = () => input.onBlur();

    const onFocus= () => input.onFocus();

    // react-selectの中ではvalueは{value: number, label: string} で扱うための処理
    const selectValue = input.value.map((item: number) => {
        return hashOptions[item]
    });

    return (
        <div>
            {label && <Label require={require} htmlFor={name} marginBottom={true}>{label}</Label>}
            <FormMultiSelect
                {...input}
                placeholder={placeholder}
                isMulti={isMulti}
                options={options}
                type={type}
                hasError={hasError}
                value={selectValue}
                onChange={onChange}
                onBlur={onBlur}
                onFocus={onFocus}
            >
                {children}
            </FormMultiSelect>
            {hasError &&
            <ErrorText>{errorText}</ErrorText>
            }
        </div>
    );
};

export default (FormGroupMultiSelect);



// WEBPACK FOOTER //
// ./src/presentation/common/molecular/form_group/form_group_multi_select.tsx